import React, { useState } from "react";
import { toast } from "sonner";
import { sendContact } from "@/lib/api";
import useMeta from "@/hooks/useMeta";

const Contact = () => {
  useMeta({
    title: "Contact — Global Leader Solutions",
    description: "Get in touch with Global Leader Solutions for group licensing, corporate training, speaking engagements, or general inquiries.",
    canonical: "https://globalleadersolutions.com/contact",
  });
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendContact(form);
      toast.success("Message received. We will be in touch.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div data-testid="contact-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-3">Contact</div>
      <h1 className="text-4xl sm:text-5xl font-serif font-semibold text-[#2D2628] mb-4">Let's talk</h1>
      <p className="text-base text-[#6B5E62] max-w-2xl mb-10 leading-relaxed">
        For speaking inquiries, corporate training, or general questions — send a note and we will
        respond within two business days.
      </p>

      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="contact-form">
        <input required value={form.name} onChange={on("name")} placeholder="Your name" data-testid="contact-name"
          className="px-4 py-3 bg-white border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm" />
        <input required type="email" value={form.email} onChange={on("email")} placeholder="Email address" data-testid="contact-email"
          className="px-4 py-3 bg-white border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm" />
        <input value={form.subject} onChange={on("subject")} placeholder="Subject (optional)" data-testid="contact-subject"
          className="md:col-span-2 px-4 py-3 bg-white border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm" />
        <textarea required rows="6" value={form.message} onChange={on("message")} placeholder="Your message" data-testid="contact-message"
          className="md:col-span-2 px-4 py-3 bg-white border border-[#E8DCDD] rounded-sm focus:ring-2 focus:ring-[#D9C5C9] focus:outline-none text-sm resize-none" />
        <div className="md:col-span-2">
          <button type="submit" disabled={loading} data-testid="contact-submit"
            className="btn-primary disabled:opacity-60">
            {loading ? "Sending..." : "Send message"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Contact;
